module.exports = "/images/settings-active.svg?c54c37d42bf8962461896a150148ec75";